import { MethodItem } from './types';

// TODO: update images
export const overview: MethodItem[] = [
  {
    image: '/images/network/transform-lives.png',
    heading: 'Transform Lives',
    copy: 'Hormonal imbalances are causing an epidemic. 28’s mission is to empower women to naturally achieve healthy hormones and their fitness goals by exercising, eating, and living in sync with their cycles. Our patented technology and world-class content delivers a holistic experience unlike any other.',
  },
  {
    image: '/images/network/earn-income.png',

    heading: 'Earn Income',
    copy: 'Earn a 25% commission for each direct referral, PLUS a portion of the referrals from your team. We incentivize equal opportunity for all partners to earn meaningful income. Like any entrepreneurial endeavor, you will earn in proportion to the effort you put in.',
  },
  {
    image: '/images/network/find-community.png',
    heading: 'Find Community',
    copy: 'Partners educate and inspire in genuine ways by sharing their personal stories and triumphs. They are the first to hear about new content and features, and play a pivotal role in improving the overall experience of 28 and in encouraging others to join.',
  },
];
